import { Seo, FaqSchema } from "@/components/site/Seo";
import { Marquee } from "@/components/site/Marquee";
import { Hero } from "@/components/sections/Hero";
import { Credentials } from "@/components/sections/Credentials";
import { Services } from "@/components/sections/Services";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { Process } from "@/components/sections/Process";
import { Battery } from "@/components/sections/Battery";
import { Installation } from "@/components/sections/Installation";
import { DetachReset } from "@/components/sections/DetachReset";
import { Troubleshoot } from "@/components/sections/Troubleshoot";
import { Gallery } from "@/components/sections/Gallery";
import { TexasMap } from "@/components/sections/TexasMap";
import { Testimonials } from "@/components/sections/Testimonials";
import { Faq } from "@/components/sections/Faq";
import { FinalCta } from "@/components/sections/FinalCta";
import { LeadForm } from "@/components/sections/LeadForm";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Seo path="/" title="Solar Company in Texas | Solar Installation, Batteries & Repair | Solar Energy Doc"
        description="Solar Energy Doc LLC is a licensed and insured Texas solar company — Tesla, Enphase and SolarEdge certified. Solar installation, batteries, detach & reset, troubleshooting, cleaning and electrical services." />
      <FaqSchema />
      <Hero />
      <Credentials />
      <Marquee />
      <Services />
      <WhyChoose />
      <Process />
      <Battery />
      <Installation />
      <Gallery />
      <DetachReset />
      <Troubleshoot />
      <TexasMap />
      <Testimonials />
      <Faq />
      <FinalCta />
      <LeadForm />
    </main>
  );
}
